module.exports = __webpack_public_path__ + "img/health.de7b8b5.svg";